/* eslint-disable semi */
/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Directives')
    .service('FormalizationService', FormalizationService)

  FormalizationService.$inject = ['$rootScope', 'NotificationService', 'DigitalSignService', 'FoundationApi']

  function FormalizationService ($rootScope, NotificationService, DigitalSignService, FoundationApi) {
    const vm = this
    const PROPOSAL_SIGNED_STATUS = 1

    function saveResendSms (operatorId, contactId, proposal) {
      DigitalSignService
        .saveResendSms({
          'user_id': operatorId,
          'contact_id': contactId,
          'proposal': proposal
        })
    }

    function checkResendCount(proposalsNumbers) {
      if ($rootScope.checkMenuAccess('formalization.canResend')) {
        return proposalsNumbers
      }

      const proposals = $rootScope.vm.proposals.filter(function (proposal) {
        return proposalsNumbers.indexOf(proposal.number) > -1;
      });

      const limit = $rootScope.vm.metadata.max_formalization_send_quantity;

      if (limit === undefined) {
        return proposalsNumbers
      }

      vm.resendLimit = limit

      const validProposalsNumbers = [];

      proposals.forEach(function (proposal) {
        const resendCounter = proposal.send_counter - 1;

        if (resendCounter < limit) {
          validProposalsNumbers.push(proposal.number);
        }
      });

      if (validProposalsNumbers.length == 0) {
        NotificationService.warningHandler(null, $rootScope.labels.resendLimitReached);
        return validProposalsNumbers;
      }

      return validProposalsNumbers;
    }

    this.openModalApproveAll = function () {
      let signedProposal = []
      const proposalsFireBase = $rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals
      selectAllProposals()

      for (let i = 0; i < $rootScope.vm.proposals.length; i++) {
        if ($rootScope.vm.proposals[i] !== null && $rootScope.vm.proposals[i].number !== '') {
          if (proposalsFireBase && proposalsFireBase[$rootScope.vm.proposals[i].number]) {
            Object.keys(proposalsFireBase[$rootScope.vm.proposals[i].number]).forEach((key) => {
              if (key === 'signedCcb') {
                signedProposal[$rootScope.vm.proposals[i].number] = true
                return true
              } else {
                signedProposal[$rootScope.vm.proposals[i].number] = false
              }
            })

            if ($rootScope.vm.proposals[i].signed && !signedProposal[$rootScope.vm.proposals[i].number]) {
              FoundationApi.publish('confirmationModal', 'open');
              return
            }
          }
          if (!$rootScope.vm.proposals[i].signed && !signedProposal[$rootScope.vm.proposals[i].number]) {
            FoundationApi.publish('confirmationModal', 'open');
            return
          }
        }
      }
      NotificationService.warningHandler('', 'Não há contratos para serem Enviados')
    }

    const selectAllProposals = () => {
      $rootScope.vm.proposals.proposalsNumber = preapareProposalsToSign(undefined, true)
      Object.values($rootScope.vm.proposals.proposalsNumber).forEach((proposal) => {
        $rootScope.vm.proposals.proposalsNumber[proposal] = true
      })
    }

    this.closeModalApproveAll = function () {
      FoundationApi.publish('confirmationModal', 'close')
    }

    this.signProposals = function (contact, proposalNumber, resubmit, approveAll) {
      if (approveAll) {
        FoundationApi.publish('confirmationModal', 'close')
      }

      let proposalsNumbers = filterProposalsSelected(approveAll, proposalNumber)

      proposalsNumbers = checkResendCount(proposalsNumbers)

      if (proposalsNumbers.length == 0) {
        return false
      }

      if (!validateFields(proposalsNumbers, approveAll)) {
        return false
      }

      const proposalsPaths = prepareProposalsPathsToSign(proposalsNumbers, resubmit)

      if (!proposalsPaths) {
        return false
      }

      checkResend(contact, proposalsNumbers)

      const payload = preparePayload(proposalsNumbers, proposalsPaths, contact, approveAll)

      DigitalSignService.approveProposal(payload)
        .$promise
        .then(function (data) {
          if (data.success) {
            NotificationService.warningHandler(data, 'Aguarde sua solicitação está sendo processada')
          } else if (!data.success && data.message) {
            NotificationService.warningHandler(data, data.message)
          } else {
            NotificationService.errorHandler(data, data.message)
          }
          proposalsNumbers.forEach(proposalNumber => {
            setStatusResubmitAndSign(proposalNumber, false, false)
          });
          FoundationApi.publish('dlgChatModal', 'close')
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao enviar proposta(s)')
          proposalsNumbers.forEach(proposalNumber => {
            setStatusResubmitAndSign(proposalNumber, false, false)
          });
        })
    }

    const filterProposalsSelected = (approveAll, proposalNumber) => {
      const proposals = []

      if (approveAll) {
        Object.entries($rootScope.vm.proposals.proposalsNumber).forEach(([proposal, status]) => {
          if (proposal.length === 13 && status) {
            proposals.push(proposal)
          }
        })
        return proposals
      }
      proposals.push(proposalNumber)
      return proposals
    }

    this.checkProposalsSigned = function () {
      let signed = []
      let digitalSignatureFireBase = []

      const element = document.getElementsByName('sendAndResendAll')[0]

      if ($rootScope.vm.selectedUser[$rootScope.vm.sector_id] &&
        $rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature &&
        $rootScope.vm.proposals
      ) {
        digitalSignatureFireBase = $rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature
        for (let i = 0; i < $rootScope.vm.proposals.length; i++) {
          if ($rootScope.vm.proposals[i]) {
            if (digitalSignatureFireBase &&
                digitalSignatureFireBase.proposals &&
                digitalSignatureFireBase.proposals[$rootScope.vm.proposals[i].number]) {
              element.disabled = false
              if (digitalSignatureFireBase.proposals[$rootScope.vm.proposals[i].number].hasOwnProperty('sending') &&
                !digitalSignatureFireBase.proposals[$rootScope.vm.proposals[i].number].sending) {
                element.disabled = true
              }

              Object.keys(digitalSignatureFireBase.proposals[$rootScope.vm.proposals[i].number]).forEach((key) => {
                if (key === 'signedCcb') {
                  signed[$rootScope.vm.proposals[i].number] = true
                  return true
                }
              })

              if ((($rootScope.vm.proposals[i].signed || digitalSignatureFireBase.proposals[$rootScope.vm.proposals[i].number].signed) &&
                    !signed[$rootScope.vm.proposals[i].number]) ||
                  (!signed[$rootScope.vm.proposals[i].number] &&
                    digitalSignatureFireBase.proposals[$rootScope.vm.proposals[i].number].sending)
              ) {
                return false
              }
            }
          }
        }
        return true
      }
    }

    function prepareProposalsPathsToSign (proposalsNumbers, resubmit) {
      let documentPath = []

      if (resubmit && vm.documentPath) {
        if (!vm.documentPath[proposalsNumbers[0]].hasOwnProperty('ccb')) {
          const proposalFireBase = $rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals[proposalsNumbers[0]]
          if (proposalFireBase.hasOwnProperty('ccb')) {
            documentPath[proposalsNumbers[0]] = Object.values($rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals[proposalsNumbers[0]].ccb)
            return documentPath
          }
          NotificationService.warningHandler(null, 'Aguarde, uma solicitação está sendo processada')
          return false
        }
        documentPath[proposalsNumbers[0]] = Object.values(vm.documentPath[proposalsNumbers[0]].ccb)
        return documentPath
      }

      proposalsNumbers.forEach(proposalNumber => {
        if ($rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals &&
            $rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals[proposalNumber] &&
            $rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals[proposalNumber].documentPath &&
            !$rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals[proposalNumber].ccb) {
          documentPath[proposalNumber] = vm.documentPath[proposalNumber]
        } else if ($rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals &&
          $rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals[proposalNumber] &&
          Object.keys($rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals[proposalNumber]).length > 1) {
          documentPath[proposalNumber] = Object.values($rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals[proposalNumber].ccb)
        } else {
          documentPath[proposalNumber] = vm.documentPath[proposalNumber]
        }
      });

      return documentPath
    }

    function preapareProposalsToSign (proposalNumber, approveAll) {
      const proposals = []
      const proposalsFireBase = $rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals
      let signedProposal = []

      if (approveAll) {
        for (let i = 0; i < $rootScope.vm.proposals.length; i++) {
          if ($rootScope.vm.proposals[i]) {
            if (proposalsFireBase && proposalsFireBase[$rootScope.vm.proposals[i].number]) {
              Object.keys(proposalsFireBase[$rootScope.vm.proposals[i].number]).forEach((key) => {
                if (key === 'signedCcb') {
                  signedProposal[$rootScope.vm.proposals[i].number] = true
                  return true
                }
              })
              if (proposalsFireBase[$rootScope.vm.proposals[i].number] && !signedProposal[$rootScope.vm.proposals[i].number]) {
                proposals.push($rootScope.vm.proposals[i].number)
                continue
              }
            }
            if (signedProposal[$rootScope.vm.proposals[i].number] && $rootScope.vm.proposals[i].signed) {
              continue
            }
            if (!$rootScope.vm.proposals[i].signed && !signedProposal[$rootScope.vm.proposals[i].number]) {
              proposals.push($rootScope.vm.proposals[i].number)
            }
          }
        }
        return proposals
      }

      proposals.push(proposalNumber)
      return proposals
    }

    function preparePayload (proposalsNumbers, proposalsPaths, contact, approveAll) {
      const user = $rootScope.vm.selectedUser[$rootScope.vm.sector_id]
      let multiApprove = false

      if (approveAll && proposalsNumbers.length > 1) {
        multiApprove = true
      }

      return {
        'proposals_numbers': Object.assign({}, proposalsNumbers),
        'contact_id': contact.id,
        'phone': user.data.contact_phone,
        'sector_id': $rootScope.vm.sector_id,
        'company_id': $rootScope.vm.operator.company_id,
        'proposals_paths': Object.assign({}, proposalsPaths),
        'contact_email': user.digital_signature.email,
        'data_nasc': vm.birthDate,
        'full_name': vm.fullName,
        'cpf': user.digital_signature.cpf,
        'channel_id': contact.data.channel_id,
        'multiApprove': multiApprove
      }
    }

    function checkResend (contact, proposalsNumbers) {
      $rootScope.vm.signing = []
      $rootScope.vm.resubmit = []
      const digitalSignatureFireBase = $rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature
      let resubmit = []

      proposalsNumbers.forEach(proposalNumber => {
        for (let i = 0; i < $rootScope.vm.proposals.length; i++) {
          if ($rootScope.vm.proposals[i]) {
            if (digitalSignatureFireBase &&
                digitalSignatureFireBase.proposals &&
                digitalSignatureFireBase.proposals[proposalNumber]) {
              if ($rootScope.vm.proposals[i].number === proposalNumber &&
                  $rootScope.vm.proposals[i].signed === 0 &&
                  !digitalSignatureFireBase.proposals[proposalNumber].signed) {
                resubmit[proposalNumber] = false
                break
              } else if ($rootScope.vm.proposals[i].number === proposalNumber &&
                  $rootScope.vm.proposals[i].signed === 1 &&
                  digitalSignatureFireBase.proposals[proposalNumber].signed) {
                resubmit[proposalNumber] = true
                break
              }
            }
          }
        }
        if (!resubmit[proposalNumber]) {
          setStatusResubmitAndSign(proposalNumber, true, false)
        } else {
          saveResendSms($rootScope.vm.operator.id, contact.id, proposalNumber)
          setStatusResubmitAndSign(proposalNumber, false, true)
        }
      });
    }

    function setStatusResubmitAndSign (proposalNumber, statusSign, statusResubmit) {
      $rootScope.vm.signing[proposalNumber] = statusSign
      $rootScope.vm.resubmit[proposalNumber] = statusResubmit
    }

    function validateFields (proposalsNumbers, approveAll) {
      let status = true

      if (proposalsNumbers.length === 0) {
        NotificationService.warningHandler('', 'Nenhum contrato foi selecionado')
        return false
      }

      const validMultiApprovals = validateMultiApprovals(approveAll)
      if (!validMultiApprovals) {
        return false
      }

      for (let index = 0; index < proposalsNumbers.length; index++) {
        if (index === 0) {
          const validName = validateName()
          if (!validName) {
            status = false
          }
          const validBirthDate = validateBirthDate()
          if (!validBirthDate) {
            status = false
          }
        }

        const validProposal = validateProposal(proposalsNumbers[index])

        if (!validProposal) {
          status = false
          continue
        }

        const validCCB = validateCCB(proposalsNumbers[index])

        if (!validCCB) {
          status = false
        }
      }

      return status
    }

    function validateCCB (proposalNumber) {
      if (!$rootScope.vm.digitalSignature.documentPath[proposalNumber] &&
          !$rootScope.vm.digitalSignature.documentPath.length &&
          !$rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals) {
        NotificationService.warningHandler('', 'Necessário o upload do CCB no contrato: ' + (proposalNumber === undefined ? '' : proposalNumber))
        return false
      } else if ($rootScope.vm.digitalSignature.documentPath.length >= 1 &&
        !$rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals) {
        NotificationService.warningHandler('', 'Necessário o upload do CCB no contrato: ' + (proposalNumber === undefined ? '' : proposalNumber))
        return false
      } else if ($rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals &&
          $rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals[proposalNumber] &&
          $rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals[proposalNumber].documentPath === 'error') {
        NotificationService.warningHandler('', 'Necessário o upload do CCB no contrato: ' + (proposalNumber === undefined ? '' : proposalNumber))
        return false
      } else if ($rootScope.vm.digital_signature_docs[proposalNumber] &&
          $rootScope.vm.digital_signature_docs[proposalNumber].hasOwnProperty('ccb')) {
        vm.documentPath = $rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature.proposals
      } else if ($rootScope.vm.digitalSignature.documentPath[proposalNumber]) {
        vm.documentPath = $rootScope.vm.digitalSignature.documentPath
      } else {
        NotificationService.warningHandler('', 'Necessário o upload do CCB no contrato: ' + (proposalNumber === undefined ? '' : proposalNumber))
        return false
      }
      return true
    }

    function validateName () {
      if ($rootScope.vm.clicksign_fullname &&
        $rootScope.vm.clicksign_fullname.metadata &&
        $rootScope.vm.clicksign_fullname.metadata.hasOwnProperty('value') &&
        $rootScope.vm.clicksign_fullname.metadata.value) {
        const fullNameArray = $rootScope.vm.clicksign_fullname.metadata.value.split(' ')
        if (fullNameArray.length > 1) {
          vm.fullName = $rootScope.vm.clicksign_fullname.metadata.value
        } else {
          NotificationService.warningHandler('', 'Insira o nome corretamente')
          return false
        }
      } else {
        NotificationService.warningHandler('', 'Insira o nome completo')
        return false
      }
      return true
    }

    function validateBirthDate () {
      if ($rootScope.vm.clicksign_birthdate &&
        $rootScope.vm.clicksign_birthdate.metadata &&
        $rootScope.vm.clicksign_birthdate.metadata.hasOwnProperty('value') &&
        $rootScope.vm.clicksign_birthdate.metadata.value) {
        vm.birthDate = $rootScope.vm.clicksign_birthdate.metadata.value
      } else {
        NotificationService.warningHandler('', 'Insira a data de nascimento')
        return false
      }
      return true
    }

    function validateProposal (proposalNumber) {
      const inputProposals = document.getElementsByName('inputProposals')
      let match = 0
      vm.proposalsNumber = []

      for (let i = 0; i < inputProposals.length; i++) {
        if (inputProposals[i].value === null || inputProposals[i].value === '') {
          NotificationService.warningHandler('', 'Insira uma proposta')
          return false
        }
        if (inputProposals[i].value === proposalNumber) {
          match++
        }
        if (match > 1) {
          NotificationService.warningHandler('', 'Proposta já existe: ' + (proposalNumber === undefined ? '' : proposalNumber))
          return false
        }
      }
      return true
    }

    function validateMultiApprovals (approveAll) {
      const proposals = [...new Set(preapareProposalsToSign(undefined, true))]

      if (approveAll === undefined && proposals.length > 1) {
        NotificationService.warningHandler('', 'É recomendável o uso do botão Aprovar/Reenviar todos')
        const element = document.getElementsByName('sendAndResendAll')[0]
        element.scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: 'center'
        })
        return false
      }
      return true
    }

    this.deleteContactProposal = function (contact, proposal, proposalIndex) {
      if (!proposal) {
        $rootScope.vm.proposals.splice(proposalIndex, 1)
        NotificationService.successHandler('', 'Proposta removida com sucesso')
        return true
      }
      DigitalSignService
        .deleteContactProposal({
          proposal: proposal,
          contact_id: contact.id
        })
        .$promise
        .then(function (data) {
          if (data.success) {
            for (let i = 0; i < $rootScope.vm.proposals.length; i++) {
              if ($rootScope.vm.proposals[i].number === proposal) {
                $rootScope.vm.proposals.splice(i, 1)
              }
            }
            NotificationService.successHandler(data, 'Proposta removida com sucesso')
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao deletar proposta!')
        })
    }

    this.showButtonDeleteProposal = function (contact, proposal) {
      if (contact) {
        if (hasProposal(proposal) &&
            proposal.signed == PROPOSAL_SIGNED_STATUS &&
            (hasDigitalSignature(contact) ||
            !hasDigitalSignatureProposal(contact, proposal))) {
          return false
        }
        if (hasProposal(proposal) &&
            hasDigitalSignatureProposal(contact, proposal) &&
            (contact.digital_signature.proposals[proposal.number].sending ||
            hasProposalSigning(proposal))) {
          return false
        }
        if (hasProposalInFireBase(contact, proposal)) {
          return false
        }
      }
      return true
    }

    function hasProposalInFireBase (contact, proposal) {
      if (proposal &&
          proposal.signed &&
          hasDigitalSignature(contact) &&
          contact.digital_signature.proposals &&
          contact.digital_signature.proposals[proposal.number]) {
        return true
      }
      return false
    }

    function hasProposal (proposal) {
      if (proposal) {
        return true
      }
      return false
    }

    function hasDigitalSignatureProposal (contact, proposal) {
      if (hasDigitalSignature(contact) &&
          contact.digital_signature.proposals &&
          contact.digital_signature.proposals[proposal.number]) {
        return true
      }
      return false
    }

    function hasDigitalSignature (contact) {
      if (contact.digital_signature) {
        return true
      }
      return false
    }

    function hasProposalSigning (proposal) {
      if (vm.signing &&
          vm.signing[proposal.number]) {
        return true
      }
      return false
    }
  }
})();
